import { USER_REQUEST, HR_USER_REQUEST } from '@/store/actions/user';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        const providerId = localStorage.getItem(`${this.user?.id}_insuranceProvider`);
        const isHr = this.$route.path.startsWith('/hr') || this.$route.name?.includes('hr');
        this.$store.dispatch(isHr ? HR_USER_REQUEST : USER_REQUEST, providerId);
      }
    },
  },
  mounted() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  },
};
